import { styled } from '@/stitches.config';
import { Box } from '@common/components';

export const StyledGradient = styled(Box, {
  alignItems: 'center',
  background: '$white',
  borderRadius: '5px',
  boxShadow: '$tooltip',
  display: 'flex',
  flexDirection: 'column',
  left: '30px',
  position: 'absolute',
  top: '50%',
  transform: 'translateX(0%) translateY(-50%)',
  zIndex: '$mapLegend',
});

export const StyledLabel = styled(Box, {
  fontSize: '$xs',
  lineHeight: '$3',
  padding: '$1',
});
